import { Fragment } from 'react';
import {
  buttonDividerStyle,
  boardHeaderStyle,
  rightButtonGroupStyle,
  fadeInRestartButtonStyle,
  wiggleCreateButtonStyle
} from './jsw-interactive-board.styles';
import { AvatarGroupImage } from './avatar-group-image';
import { CreateButton } from './create-button';
import { RestartButton } from './restart-button';
import { SpotlightTarget } from './common';
import { useInteractiveBoardStore } from './state';
import { Steps } from './constants/ui';

export const BoardHeader = () => {
  const [{ isDemoComplete, step }] = useInteractiveBoardStore();
  return (
    <div css={boardHeaderStyle}>
      <AvatarGroupImage />
      <div css={rightButtonGroupStyle}>
        <SpotlightTarget
          style={
            step === Steps.CREATE_FIRST_STORY
              ? wiggleCreateButtonStyle
              : undefined
          }
          name="openIssueModalButton"
          pulseSize={20}
          speed="slow"
        >
          <CreateButton />
        </SpotlightTarget>
        {isDemoComplete && (
          <Fragment>
            <div css={[buttonDividerStyle, fadeInRestartButtonStyle]} />
            <RestartButton />
          </Fragment>
        )}
      </div>
    </div>
  );
};
